import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import Loader from './components/loader';
import * as serviceWorker from './serviceWorker';
import { authenticate } from './auth';

const root = createRoot(document.getElementById('root'));
root.render(<Loader />);
authenticate.then(() => {
  root.render(<App />);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
